import * as React from 'react';
import Svg, {
  SvgProps, G, Rect, Path, Defs, ClipPath,
} from 'react-native-svg';

const AvatarIcon16 = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Rect width={16} height={16} fill="#E6EEF7" rx={8} />
      <Path
        fill="#548FC8"
        d="M16 16.666v-3.145c0-.58-.421-1.137-1.172-1.547-.75-.41-1.767-.641-2.828-.641H4c-1.06 0-2.078.23-2.828.64-.75.411-1.172.968-1.172 1.548v3.145M8 10a2.667 2.667 0 1 0 0-5.333A2.667 2.667 0 0 0 8 10Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={16} fill="#fff" rx={8} />
      </ClipPath>
    </Defs>
  </Svg>
);
export default AvatarIcon16;
